import { context } from '@wikia/ad-engine';

export function getRubiconDisplayContext(): object {
	const floorAdhesionConfigs = context.get('experiments.persistentAdhesionExperiment')
		? {
				adhesion_limited: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.adhesion_limited ?? [
						[300, 50],
						[320, 50],
					],
					siteId: '23565',
					zoneId: '3477728',
				},
			}
		: {
				floor_adhesion: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.floor_adhesion ?? [
						[300, 50],
						[320, 50],
						[320, 100],
					],
					siteId: '23565',
					zoneId: '1422262',
				},
			};

	return {
		enabled: false,
		accountId: 7450,
		slots: {
			mobile_top_leaderboard: {
				sizes: [[320, 50]],
				position: 'atf',
				siteId: '23565',
				zoneId: '87671',
			},
			mobile_in_content: {
				sizes: [[300, 250]],
				siteId: '23565',
				zoneId: '87671',
			},
			bottom_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.bottom_leaderboard ?? [
					[300, 250],
					[320, 50],
				],
				siteId: '23565',
				zoneId: '87671',
			},
			...floorAdhesionConfigs,
			interstitial: {
				sizes: [[320, 480]],
				siteId: '23565',
				zoneId: '2229522',
			},
			gallery_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.gallery_leaderboard ?? [
					[320, 100],
					[320, 50],
				],
				siteId: '23565',
				zoneId: '2964780',
			},
		},
	};
}
